import React from 'react';
import PropTypes from 'prop-types';
import './Wrapper.scss';

const Wrapper = ({ children, className, title, bottomLink }) => (
  <div className={`hc-wrapper ${className || ''}`}>
    {title && <h4 className="hc-wrapper__title">{title}</h4>}
    <div className="hc-wrapper__content">{children}</div>
    {bottomLink && (
      <div className="hc-wrapper__bottom">
        <div className="hc-wrapper__bottom-link">{bottomLink}</div>
      </div>
    )}
  </div>
);

Wrapper.propTypes = {
  title: PropTypes.string,
  className: PropTypes.string,
  bottomLink: PropTypes.node,
  children: PropTypes.node.isRequired,
};

export default Wrapper;
